<template>
    <r-dialog
        v-bind="$attrs"
        v-on="$listeners"
        :max-width="maxWidth"
        overlay-color="#2D0066"
        overlay-opacity="0.18"
    >
        <v-card
            class="glass-dialog-card"
            elevation="0"
        >
            <div
                v-if="title || $slots.title || showClose"
                class="d-flex align-center pa-6 pb-0"
                style="gap:12px"
            >
                <h3 class="card-title-strong mr-auto" style="margin:0">
                    <slot name="title">{{ title }}</slot>
                </h3>
                <v-btn
                    v-if="showClose"
                    icon
                    @click="$emit('input', false); $emit('close')"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-text class="pt-4">
                <slot />
            </v-card-text>

            <v-card-actions
                v-if="$slots.actions"
                class="d-flex justify-end"
                style="gap:8px"
            >
                <slot name="actions" />
            </v-card-actions>
        </v-card>
    </r-dialog>
</template>

<script>
export default {
    name: 'GlassDialog',
    inheritAttrs: false,
    props: {
        title: { type: String, default: '' },
        maxWidth: { type: [String, Number], default: 520 },
        showClose: { type: Boolean, default: true },
    },
}
</script>
